import { Entity } from './types';
import { get } from 'lodash';

export const Refund = (item: Entity.Refund): Entity.Refund => ({
  id: get(item, 'id') || 0,
  level: get(item, 'level') || 0
});
